/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Typography, useTheme, Stack, TextField,
} from '@mui/material';
import {
  ErrorBox,
  ErrorMessage,
  ErrorTitle,
  FormDialog,
  FormDialogActions,
  FormDialogContent,
  FormDialogTitle,
  FormCancelButton,
  getFormProps,
  getFieldProps,
  getSubmitButtonProps,
} from '@marageti/z4-lib';
import { LoadingButton } from '@mui/lab';

import { useFormContext } from 'react-hook-form';
import { ViewProps } from './types';

const InviteSpecialistFormView = ({
  onCancel,
  onSubmit,
  open,
  submissionError,
  roleOptions,
}: ViewProps) => {
  const theme = useTheme();

  const {
    handleSubmit,
    formState: {
      errors,
      isSubmitting,
      isValid,
      touchedFields,
    },
    getFieldState,
    register,
  } = useFormContext();

  return (
    <FormDialog
      open={open}
    >
      <FormDialogTitle handleClose={onCancel}>
        <Typography
          sx={{
            fontSize: theme.typography.h3,
          }}
        >
          Invite Specialist
        </Typography>
      </FormDialogTitle>
      <form
        name="invite-user-form"
        {...getFormProps(handleSubmit(onSubmit))}
      >
        <FormDialogContent>
          <Stack>
            <TextField
              id="email"
              label="Email Address"
              required
              {...register('email')}
              {...getFieldProps('email', errors)}
              color={!getFieldState('email').invalid && touchedFields.email ? 'success' : 'primary'}
            />

            <TextField
              id="givenName"
              label="First Name"
              required
              {...register('givenName')}
              {...getFieldProps('givenName', errors)}
            />

            <TextField
              id="familyName"
              label="Last Name"
              required
              {...register('familyName')}
              {...getFieldProps('familyName', errors)}
            />

            <TextField
              select
              SelectProps={{
                native: true,
              }}
              id="role"
              label="Role"
              required
              {...register('role')}
            >
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <option value="" />
              {roleOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </TextField>
          </Stack>

          {submissionError && (
            submissionError.message.includes('must have an enabled agent admin') ? (
              <ErrorBox>
                <ErrorTitle>
                  Error: Manager Account Required
                </ErrorTitle>
                <ErrorMessage>
                  The Partner must have at least one active manager role account.
                  Please update before sending the invitation.
                </ErrorMessage>
              </ErrorBox>
            ) : (
              <ErrorBox>
                <ErrorTitle>
                  There was an error on our end.
                </ErrorTitle>
                <ErrorMessage>
                  {`Code: ${submissionError.code}: ${submissionError.message}`}
                </ErrorMessage>
              </ErrorBox>
            )
          )}
        </FormDialogContent>
        <FormDialogActions>
          <FormCancelButton onClick={onCancel} />
          <LoadingButton
            type="submit"
            variant="contained"
            {...getSubmitButtonProps(isSubmitting, isValid)}
          >
            Submit
          </LoadingButton>
        </FormDialogActions>
      </form>
    </FormDialog>
  );
};

export default InviteSpecialistFormView;
